/**
 * `styleStatus` → operator-facing label + StatusPill tone. The full V1
 * lifecycle is represented so later-increment statuses (costing_locked …
 * shipped) render with the right chrome once those increments drive them.
 *
 * @see packages/api-contract/src/procedures/styles.ts (styleStatus)
 */
import type { StatusTone } from "@flint/ui";

export type StyleStatus =
  | "draft"
  | "po_confirmed"
  | "costing_locked"
  | "pp_approved"
  | "in_production"
  | "shipped"
  | "closed"
  | "cancelled";

const META: Record<StyleStatus, { label: string; tone: StatusTone }> = {
  draft: { label: "Draft", tone: "muted" },
  po_confirmed: { label: "Confirmed", tone: "sky" },
  costing_locked: { label: "Costing locked", tone: "sky" },
  pp_approved: { label: "PP approved", tone: "ok" },
  in_production: { label: "In production", tone: "warn" },
  shipped: { label: "Shipped", tone: "ok" },
  closed: { label: "Closed", tone: "ok" },
  cancelled: { label: "Cancelled", tone: "bad" },
};

export function styleStatusLabel(status: StyleStatus): string {
  return META[status]?.label ?? status;
}

export function styleStatusTone(status: StyleStatus): StatusTone {
  return META[status]?.tone ?? "muted";
}
